'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/MagnifyingGlass.js";
var m = Object.defineProperty, f = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var g = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var i = (e, a, o) => a in e ? m(e, a, { enumerable: true, configurable: true, writable: true, value: o }) : e[a] = o, s = (e, a) => {
  for (var o in a || (a = {}))
    g.call(a, o) && i(e, o, a[o]);
  if (r)
    for (var o of r(a))
      p.call(a, o) && i(e, o, a[o]);
  return e;
}, t = (e, a) => f(e, n(a));
const w = forwardRef((e, a) => /* @__PURE__ */ a__default.createElement(b, t(s({ ref: a }, e), { weights: t$1 })));
w.displayName = "MagnifyingGlass";
export {
  w as MagnifyingGlass
};
